import ReactCurrencyInput from "react-currency-input";
import { FormGroup } from "reactstrap";
import React from 'react';

const CurrencyInput = (props) => {
  return (
    <FormGroup>
      <ReactCurrencyInput
        decimalSeparator=","
        thousandSeparator="."
        prefix="R$ "
        
        className="form-control"
        {...props}
      />
    </FormGroup>
  );
};

export default CurrencyInput;
